import React from 'react'
import PageConfig from '@/component/layout/PageConfig.tsx'
import { TYPE_TopNav } from '@/component/layout/TopNav/TopNav.tsx'
import Footer from '@/component/layout/Footer/Footer.tsx'

const LocationPrivacyPage: React.FC = () => {
    return (
        <PageConfig showTopNav={true} typeTopNav={TYPE_TopNav.GUIDE}>
            <div className={'section_800 py-[60px] md:py-[30px] px-[24px]'}>
                <h1 className={'text-[28px] md:text-[22px] font-bold mb-[32px]'}>개인위치정보 처리방침</h1>

                <section className={'mb-[32px] p-[20px] border border-gray3 rounded-[8px] bg-gray1'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>개인위치정보 처리방침 개정 안내</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[16px]'}>
                        돌봄드림 주식회사는 위치정보법 준수 및 개인위치정보 보호 강화를 위하여 개인위치정보 처리방침을 아래와 같이 개정합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>
                            변경일시
                            <p className={'mt-[2px]'}>2026년 6월 22일</p>
                        </li>
                        <li className={'mt-[8px]'}>
                            시행일
                            <p className={'mt-[2px]'}>2026년 6월 22일</p>
                        </li>
                        <li className={'mt-[8px]'}>
                            변경사유
                            <p className={'mt-[2px]'}>개인위치정보의 파기 절차 및 방법 등 개인위치정보 처리방침 필수 명시사항을 명확히 반영하기 위함</p>
                        </li>
                        <li className={'mt-[8px]'}>
                            주요 변경내용
                            <ul className={'list-disc pl-[20px] mt-[2px]'}>
                                <li>개인위치정보의 파기 절차 및 방법 조항 신설</li>
                                <li>개인위치정보의 처리목적 달성, 보유기간 경과, 동의 철회, 서비스 이용계약 종료 시 지체 없이 파기한다는 내용 명시</li>
                                <li>파기 절차로 파기 사유 발생 여부 확인, 파기 대상 개인위치정보 및 관련 데이터 식별, 삭제 처리, 파기 결과 확인 및 기록 관리 절차 명시</li>
                                <li>파기 방법으로 전자적 파일의 영구 삭제, 데이터베이스 삭제 또는 비식별화, 종이 문서의 분쇄 또는 소각, 백업 데이터 삭제 방식 명시</li>
                                <li>위치정보관리책임자 및 회사 주소 등 현행화</li>
                            </ul>
                        </li>
                        <li className={'mt-[8px]'}>
                            개정 처리방침 적용 대상
                            <p className={'mt-[2px]'}>Carearly 개인위치정보 처리방침</p>
                        </li>
                    </ol>
                </section>

                <p className={'text-[14px] text-gray4 leading-[1.8] mb-[28px]'}>
                    돌봄드림 주식회사(이하 "회사"라고 합니다)는 「위치정보의 보호 및 이용 등에 관한 법률」 및 관련 법령에 따라 개인위치정보를 안전하게 처리하고 보호하기 위하여 다음과 같이 개인위치정보 처리방침을 수립·공개합니다.
                </p>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제1조 (개인위치정보의 처리목적 및 보유기간)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 다음의 목적을 위하여 개인위치정보를 처리합니다. 처리한 개인위치정보는 아래의 목적 이외의 용도로 이용하지 않으며, 이용 목적이 변경되는 경우에는 관련 법령에 따라 필요한 조치를 이행합니다.
                    </p>
                    <div className={'overflow-x-auto mt-[8px] mb-[8px]'}>
                        <table className={'w-full border-collapse border border-gray3 text-[13px]'}>
                            <thead>
                                <tr className={'bg-gray1'}>
                                    <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>서비스명</th>
                                    <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>처리목적</th>
                                    <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>개인위치정보 보유기간</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>Carearly 위치기반서비스</td>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>보호 대상자의 현재 위치 확인, 이동 경로 확인, 낙상 감지 및 위험 상황 알림, 보호자 및 관리자의 위치 기반 돌봄 지원, 안전관리 및 응급상황 대응</td>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>서비스 이용 종료 시까지. 다만, 다른 법률에 따라 보유하여야 하거나 회원이 개인위치정보의 보유에 별도로 동의한 경우에는 해당 법률 또는 별도 동의 범위 내에서 최대 1년간 보유할 수 있습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        회사는 개인위치정보의 처리목적이 달성된 경우에는 위치정보 수집·이용·제공사실 확인자료를 제외한 개인위치정보를 지체 없이 파기합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제2조 (개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항에 따라 개인위치정보의 수집·이용·제공사실 확인자료를 위치정보시스템에 자동으로 기록·보존합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사가 기록·보존하는 개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간은 다음과 같습니다.
                    </p>
                    <div className={'overflow-x-auto mt-[8px] mb-[8px]'}>
                        <table className={'w-full border-collapse border border-gray3 text-[13px]'}>
                            <thead>
                                <tr className={'bg-gray1'}>
                                    <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>구분</th>
                                    <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>보유근거</th>
                                    <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>보유기간</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>개인위치정보 수집사실 확인자료</td>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항</td>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>6개월</td>
                                </tr>
                                <tr>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>개인위치정보 이용·제공사실 확인자료</td>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항</td>
                                    <td className={'border border-gray3 px-[12px] py-[8px]'}>6개월</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제3조 (개인위치정보의 수집방법)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 서비스 제공을 위하여 다음 각 호의 방법으로 개인위치정보를 수집합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회원 또는 보호 대상자가 사용하는 스마트폰, 웨어러블 기기, IoT 디바이스 등 위치정보 수집 기능이 있는 단말기를 통한 수집</li>
                        <li>GPS, Wi-Fi, 기지국 정보(Cell-ID), IP 기반 위치정보, 그 밖에 단말기 및 통신망에서 제공하는 위치 측위 정보를 통한 수집</li>
                        <li>회사의 디바이스 또는 애플리케이션이 서버와 통신하는 과정에서 UDP, MQTT, HTTPS 등 통신방식을 통해 전송되는 위치정보의 수집</li>
                        <li>회원이 서비스 이용 과정에서 위치정보 수집에 동의한 후 서비스 화면, 관제 시스템, 보호자 연동 기능 등을 통해 이루어지는 위치정보의 수집</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        회사는 서비스 제공에 필요한 최소한의 범위에서 개인위치정보를 수집합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제4조 (개인위치정보의 파기 절차 및 방법)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 개인위치정보의 처리목적이 달성되거나 보유기간이 경과한 경우, 또는 회원이 동의를 철회하거나 서비스 이용계약이 종료된 경우에는 해당 개인위치정보를 지체 없이 파기합니다. 다만, 다른 법률에 따라 보존하여야 하는 경우에는 해당 법률에서 정한 기간 동안 별도로 분리하여 보관할 수 있습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>개인위치정보의 파기 절차는 다음과 같습니다.</p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px] mb-[8px]'}>
                        <li>파기 사유 발생 여부 확인</li>
                        <li>파기 대상 개인위치정보 및 관련 데이터 식별</li>
                        <li>내부 승인 또는 시스템 자동처리 절차에 따른 삭제 처리</li>
                        <li>파기 결과 확인 및 파기 기록 관리</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>개인위치정보의 파기 방법은 다음과 같습니다.</p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>전자적 파일 형태로 저장된 개인위치정보는 복구 또는 재생이 불가능한 방법으로 영구 삭제합니다.</li>
                        <li>데이터베이스에 저장된 개인위치정보는 삭제 처리하거나 복구가 불가능하도록 비식별화 또는 영구 삭제합니다.</li>
                        <li>종이 문서에 출력된 개인위치정보가 있는 경우에는 분쇄 또는 소각의 방법으로 파기합니다.</li>
                        <li>백업 데이터에 포함된 개인위치정보는 백업 보관주기 및 내부 파기정책에 따라 복구 또는 재생이 불가능한 방법으로 삭제합니다.</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        회사는 개인위치정보의 파기 결과를 확인하고, 파기 일시, 파기 대상, 파기 방법, 처리 담당자 등을 기록·관리할 수 있습니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제5조 (개인위치정보의 제3자 제공에 관한 사항)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 회원의 사전 동의가 있거나 법령에 특별한 규정이 있는 경우를 제외하고 개인위치정보를 제3자에게 제공하지 않습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사가 회원이 지정한 보호자, 관리자, 기관 담당자 등 제3자에게 개인위치정보를 제공하는 경우에는 제공받는 자, 제공목적, 제공항목, 제공기간을 사전에 회원에게 고지하고 동의를 받습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우, 개인위치정보를 수집한 해당 통신단말장치 또는 회원이 미리 지정한 전자우편주소 등으로 매회 회원에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        다만, 다음 각 호에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보할 수 있습니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>개인위치정보를 수집한 해당 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                        <li>회원이 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        회원은 관련 법령에 따라 정보제공내역을 모아서 통보받는 방법을 선택할 수 있으며, 회원이 회사의 절차에 따라 요청할 경우 즉시 통보 방법으로 변경할 수 있습니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제6조 (개인위치정보주체의 권리 및 행사방법)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회원이 동의의 전부를 철회한 경우 회사는 수집한 개인위치정보 및 위치정보 수집·이용·제공사실 확인자료를 지체 없이 파기합니다. 단, 동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 수집·이용·제공사실 확인자료에 한합니다. 다만, 관련 법령에 따라 보관하여야 하는 자료는 해당 법령에서 정한 기간 동안 보관할 수 있습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회원은 회사에 대하여 언제든지 개인위치정보의 이용 또는 제공의 일시적인 중지를 요구할 수 있고, 회사는 이를 거절할 수 없으며 이를 위한 기술적 수단을 갖추고 있습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        회원은 회사에 대하여 다음 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 해당 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절하지 않습니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>본인에 대한 위치정보 수집·이용·제공사실 확인자료</li>
                        <li>본인의 개인위치정보가 「위치정보의 보호 및 이용 등에 관한 법률」 또는 다른 법률에 따라 제3자에게 제공된 이유 및 내용</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        회원은 위 권리를 행사하기 위하여 회사의 고객센터 또는 위치정보관리책임자에게 문의할 수 있습니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제7조 (법정대리인의 권리 및 행사방법)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 14세 미만 아동의 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대하여 해당 아동과 그 법정대리인 모두의 동의를 받아야 합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        법정대리인은 해당 아동의 개인위치정보에 대하여 제6조에 따른 개인위치정보주체의 권리를 모두 행사할 수 있습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        회사는 다음 각 호의 어느 하나에 해당하는 방법으로 법정대리인이 동의했는지를 확인합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 회사가 그 동의 표시를 확인했음을 법정대리인의 휴대전화 문자메시지로 알리는 방법</li>
                        <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 법정대리인의 신용카드·직불카드 등의 카드정보를 제공받는 방법</li>
                        <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법</li>
                        <li>동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나 우편 또는 팩스를 통하여 전달하고, 법정대리인이 동의 내용에 대하여 서명날인 후 제출하도록 하는 방법</li>
                        <li>동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우편을 전송받는 방법</li>
                        <li>전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나, 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법</li>
                        <li>그 밖에 위 방법에 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제8조 (8세 이하의 아동 등의 보호의무자의 권리·의무 및 행사방법)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        회사는 다음 각 호의 어느 하나에 해당하는 자의 보호의무자가 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px] mb-[8px]'}>
                        <li>8세 이하의 아동</li>
                        <li>피성년후견인</li>
                        <li>「장애인복지법」 제2조제2항제2호에 따른 정신적 장애를 가진 사람으로서 「장애인고용촉진 및 직업재활법」 제2조제2호에 따른 중증장애인에 해당하는 사람</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        보호의무자는 8세 이하의 아동 등을 사실상 보호하는 자로서 다음 각 호의 어느 하나에 해당하는 자를 말합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px] mb-[8px]'}>
                        <li>8세 이하의 아동의 법정대리인 또는 「보호시설에 있는 미성년자의 후견 직무에 관한 법률」 제3조에 따른 후견인</li>
                        <li>피성년후견인의 법정대리인</li>
                        <li>제1항제3호에 해당하는 사람의 법정대리인 또는 관련 법령에 따른 보호시설의 장</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        보호의무자가 개인위치정보의 이용 또는 제공에 동의하려는 경우에는 다음 각 호의 사항을 기재하여 기명날인 또는 서명한 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>8세 이하의 아동 등의 성명, 주소 및 생년월일</li>
                        <li>보호의무자의 성명, 주소 및 연락처</li>
                        <li>개인위치정보 이용 또는 제공의 목적이 8세 이하의 아동 등의 생명 또는 신체의 보호에 한정된다는 사실</li>
                        <li>동의의 연월일</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 제6조에 따른 개인위치정보주체의 권리를 모두 행사할 수 있습니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제9조 (개인위치정보의 안전성 확보조치)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        회사는 개인위치정보의 유출, 변조, 훼손 등을 방지하기 위하여 다음 각 호의 관리적·기술적 보호조치를 시행합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>위치정보관리책임자의 지정</li>
                        <li>개인위치정보의 수집·이용·제공·파기 등 각 단계별 접근권한자 지정 및 권한 제한</li>
                        <li>위치정보 취급자의 의무와 책임을 규정한 취급·관리 절차 및 지침 마련</li>
                        <li>위치정보 수집·이용·제공사실 확인자료가 포함된 취급대장의 운영·관리</li>
                        <li>위치정보 보호조치에 대한 정기적인 자체점검 실시</li>
                        <li>위치정보시스템 접근권한 확인을 위한 식별 및 인증</li>
                        <li>위치정보시스템에 대한 권한 없는 접근을 차단하기 위한 방화벽 등 접근통제 조치</li>
                        <li>위치정보시스템에 대한 접근사실의 전자적 자동 기록·보존</li>
                        <li>침해사고 방지를 위한 보안프로그램 설치 및 운영</li>
                        <li>개인위치정보를 안전하게 저장·전송할 수 있는 암호화 기술 적용 또는 이에 상응하는 보호조치</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제10조 (위치정보관리책임자 및 고충처리 부서)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 개인위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 위치정보관리책임자를 지정하여 운영합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>회사의 위치정보관리책임자는 다음과 같습니다.</p>
                    <div className={'text-[14px] text-gray4 leading-[1.8] pl-[20px] mb-[8px]'}>
                        <p>성명 : 김석현</p>
                        <p>직책 : CTO</p>
                        <p>대표전화 : 070-4452-5300</p>
                        <p>전자우편 : bruno@dolbomdream.com</p>
                    </div>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>개인위치정보 관련 고충처리 부서는 다음과 같습니다.</p>
                    <div className={'text-[14px] text-gray4 leading-[1.8] pl-[20px]'}>
                        <p>부서명 : 서비스 운영팀</p>
                        <p>대표전화 : 070-4452-5300</p>
                        <p>전자우편 : dev@dolbomdream.com</p>
                    </div>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제11조 (회사의 연락처)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>회사의 상호, 대표자, 주소 및 연락처는 다음과 같습니다.</p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>상호 : 돌봄드림 주식회사</li>
                        <li>대표자 : 김지훈</li>
                        <li>주소 : 대전광역시 중구 중앙로 119, 디스테이션 1003호(선화동)</li>
                        <li>대표전화 : 070-4452-5300</li>
                        <li>전자우편 : dev@dolbomdream.com</li>
                        <li>홈페이지 : https://dolbomdream.com/</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>부칙</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        제1조 (시행일) 이 처리방침은 2026년 6월 22일부터 시행합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[4px]'}>
                        제2조 (기존 처리방침의 개정) 본 처리방침 시행일 이전의 개인위치정보 처리방침은 본 처리방침으로 대체됩니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        제3조 (위치정보관리책임자) 2026년 6월 22일 기준 회사의 위치정보관리책임자는 다음과 같습니다.
                    </p>
                    <div className={'text-[14px] text-gray4 leading-[1.8] pl-[20px] mt-[4px]'}>
                        <p>성명 : 김석현</p>
                        <p>직책 : CTO</p>
                        <p>대표전화 : 070-4452-5300</p>
                        <p>전자우편 : bruno@dolbomdream.com</p>
                    </div>
                </section>
            </div>
            <Footer />
        </PageConfig>
    )
}

export default LocationPrivacyPage
